<template>
  <IconMask src="/images/logo/white.svg" />
</template>
